import { useMutation } from '@tanstack/react-query';
import { Button, message, Modal, Table } from 'antd';
import { FC, useState } from 'react';

import { HRModel } from '@/modules/hr-management/models';
import { useCreateRecruitmentAddMember } from '@/modules/recruitment-organization/hooks/useCreateRecruitmentAddMember';
import { useGetHRListByRecruitmentPlanId } from '@/modules/recruitment-organization/hooks/useGetHRListByRecruitmentPlanId';

interface IProps {
  readonly onHide?: () => void;
  readonly onSaved?: () => void;
  readonly planId?: string;
  readonly show?: boolean;
}

// QC #14 — nút "Thêm nhân sự" tại tab Chia chỉ tiêu (Tổ chức tuyển dụng)
// trước đây mở nhầm popup "Thêm nhóm tuyển dụng vào chiến dịch". Modal này
// hiển thị danh sách NHÂN SỰ thuộc các nhóm đã được phân bổ chỉ tiêu từ Kế
// hoạch tuyển dụng (GET /recruitment-org/filter-employee) để chọn và thêm
// vào chiến dịch (POST /recruitment-org/add-member), sau đó chia chỉ tiêu
// từng người bằng edit inline có sẵn trong bảng.
const AddMemberModal: FC<IProps> = (props) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const { data: hrList, isLoading } = useGetHRListByRecruitmentPlanId(props.planId);
  const { mutateAsync: addMembers } = useCreateRecruitmentAddMember();
  const { mutateAsync, isLoading: saving } = useMutation(addMembers);

  const handleSubmit = async () => {
    if (!selectedIds.length) {
      message.warning('Chọn ít nhất 1 nhân sự');

      return;
    }
    const res = await mutateAsync({ member_ids: selectedIds, plan_id: props.planId || '' });
    if (!res) return;

    props.onSaved?.();
    props.onHide?.();
  };

  return (
    <Modal
      footer={
        <>
          <Button onClick={props.onHide}>Hủy</Button>
          <Button loading={saving} onClick={handleSubmit} type="primary">
            Thêm {selectedIds.length > 0 ? `(${selectedIds.length})` : ''}
          </Button>
        </>
      }
      onCancel={props.onHide}
      open={props.show}
      title="Thêm nhân sự vào chiến dịch"
      width={640}
      centered
    >
      <Table<HRModel>
        columns={[
          { dataIndex: 'name', key: 'name', title: 'Họ tên' },
          { dataIndex: 'code', key: 'code', title: 'Mã NS' },
          { dataIndex: 'phone', key: 'phone', title: 'SĐT' },
          { dataIndex: 'target', key: 'target', title: 'Chỉ tiêu hiện tại' },
        ]}
        dataSource={hrList?.rows}
        loading={isLoading}
        locale={{ emptyText: 'Chiến dịch chưa có nhóm nào được phân bổ chỉ tiêu' }}
        pagination={false}
        rowKey="id"
        rowSelection={{
          onChange: (keys) => setSelectedIds(keys as string[]),
          selectedRowKeys: selectedIds,
        }}
        scroll={{ y: 360 }}
        size="small"
      />
    </Modal>
  );
};

export { AddMemberModal };
